/**
 * @file Generated by js-routes 2.3.6. Based on Rails 8.1.3 routes of LixiAtlas::Application.
 * @version 52203ce604616de75350f05a5954f68dc1d0302e8276a58ed320750f2e4ae83d
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    false
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const activity_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

export const admin_claude_questions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"claude-questions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const admin_design_system_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"design-system"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const admin_glossary_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"glossary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const admin_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const admin_imports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"imports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const admin_integrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const admin_integrations_google_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const admin_integrations_google_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const admin_integrations_slack_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"slack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const admin_integrations_slack_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const approve_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const assign_product_nodes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product-groups"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const assign_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const assignees_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assignees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const bookmark_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bookmarks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const bookmarks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bookmarks"],[1,[2,[8,"."],[3,"format"]]]]]);

export const claim_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const close_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const comment_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const comment_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

export const data_admin_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const deactivate_team_member_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const go_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"go"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const impersonate_team_member_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impersonate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const inventory_overview_path = /*#__PURE__*/ __jsr.r({"market_slug":{},"format":{}}, [2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"overview"],[2,[1,[2,[7,"/"],[3,"market_slug"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

export const login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

export const logout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

export const market_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const market_switch_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"market-switch"],[1,[2,[8,"."],[3,"format"]]]]]);

export const mcp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]);

export const message_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const move_org_node_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org-structure"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const move_product_node_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product-groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const native_oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const nudge_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"nudge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const oauth_introspect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const oauth_register_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const oauth_revoke_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const oauth_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const onboarding_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]]);

export const org_node_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org-structure"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const org_nodes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org-structure"],[1,[2,[8,"."],[3,"format"]]]]]);

export const org_revenue_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"revenue"],[1,[2,[8,"."],[3,"format"]]]]]);

export const org_revenue_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"revenue"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const people_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const pick_market_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pick-market"],[1,[2,[8,"."],[3,"format"]]]]]);

export const plan_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const plan_actuals_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"actuals"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const plan_actuals_channel_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"actuals"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_actuals_export_sales_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"actuals"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"export-sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_actuals_index_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"actuals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const plan_bottom_up_by_day_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-day"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_day_channel_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-day"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_day_import_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"by-day"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_day_index_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-day"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_channel_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_context_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"context"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_edit_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_export_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_import_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_import_revenue_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"import-revenue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_index_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_review_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_submit_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_by_month_tasks_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-month"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_day_pricing_bulk_destroy_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-day"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"day-pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_day_pricing_bulk_update_label_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-day"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"day-pricing"],[2,[7,"/"],[2,[6,"label"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_day_pricing_bulk_upsert_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[6,"by-day"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"day-pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_bottom_up_periods_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"bottom-up"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"periods"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_index_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const plan_pipeline_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"pipeline"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const plan_pipeline_index_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"pipeline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const plan_product_pricings_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const plan_product_pricings_edit_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_product_pricings_export_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const plan_product_pricings_index_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const plan_product_pricings_price_level_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"price-levels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_product_pricings_price_levels_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"price-levels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const plan_product_pricings_prices_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"prices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const plan_product_pricings_products_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const plan_product_pricings_remove_product_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"product_external_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_external_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_product_pricings_review_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_product_pricings_search_products_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_product_pricings_submit_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_product_pricings_upload_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"channel_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"product-pricings"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"channel_slug"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const plan_top_down_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_by_channel_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"by-channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_by_channel_quarterly_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"by-channel-quarterly"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_complete_channel_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"complete-channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_complete_overall_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"complete-overall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_complete_quarterly_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"complete-quarterly"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_destroy_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const plan_top_down_discard_draft_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"discard-draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_nodes_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_review_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"task_id":{},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"review"],[2,[1,[2,[7,"/"],[3,"task_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

export const plan_top_down_review_comment_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"task_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

export const plan_top_down_review_comments_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_top_down_revision_request_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"revision-request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_revision_request_comment_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"revision-request"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

export const plan_top_down_revision_request_comments_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"revision-request"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const plan_top_down_revision_request_new_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"revision-request"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const plan_top_down_select_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[6,"select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const plan_top_down_submit_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"task_id":{},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"submit"],[2,[1,[2,[7,"/"],[3,"task_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

export const plan_top_down_update_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const plan_top_down_update_channel_quarter_targets_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"update-channel-quarter-targets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_update_channel_targets_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"update-channel-targets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const plan_top_down_versioned_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"slug":{"r":true},"version_number":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"top-down"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"version_number"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const product_node_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product-groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const product_nodes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product-groups"],[1,[2,[8,"."],[3,"format"]]]]]);

export const product_quick_view_path = /*#__PURE__*/ __jsr.r({"external_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"external_id"],[2,[7,"/"],[2,[6,"quick-view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const products_product_nodes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product-groups"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const products_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const products_warehouse_channel_products_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"warehouse_channel_products"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const purchase_destinations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[6,"destinations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const purchase_incoming_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[6,"incoming"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const purchase_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const push_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"push"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const push_review_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"push"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const push_review_action_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"push"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const push_review_actions_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"push"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const rails_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const reactivate_team_member_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const read_all_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"read_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const read_notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const reject_team_onboarding_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"onboarding_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const request_changes_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const reset_admin_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const revenue_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"revenue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const revenue_products_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"revenue"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

export const seed_warehouse_channel_products_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"warehouse_channel_products"],[2,[7,"/"],[2,[6,"seed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const settings_profile_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const settings_profile_avatar_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const settings_profile_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const settings_task_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"task-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const settings_task_settings_manual_trigger_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"task-settings"],[2,[7,"/"],[2,[6,"manual-trigger"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const settings_task_settings_manual_trigger_quarterly_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"task-settings"],[2,[7,"/"],[2,[6,"manual-trigger-quarterly"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]);

export const slack_login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"slack_login"],[1,[2,[8,"."],[3,"format"]]]]]);

export const slack_login_verify_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"slack_login"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const snooze_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"snooze"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const stop_impersonation_team_members_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"stop_impersonation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const submission_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"comment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const submissions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[1,[2,[8,"."],[3,"format"]]]]]);

export const sync_admin_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]);

export const team_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[1,[2,[8,"."],[3,"format"]]]]]);

export const team_member_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const team_members_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const team_role_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const team_roles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const test_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const user_role_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const user_roles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_roles"],[1,[2,[8,"."],[3,"format"]]]]]);

export const warehouse_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"warehouses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const warehouse_channel_product_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"warehouse_channel_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const warehouse_channel_products_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"warehouse_channel_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const warehouses_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"warehouses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wholesale_customer_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"wholesale"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const wholesale_customers_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"wholesale"],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const wholesale_forecast_by_account_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"wholesale"],[2,[7,"/"],[2,[6,"forecast-by-account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const wholesale_forecast_by_account_export_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"wholesale"],[2,[7,"/"],[2,[6,"forecast-by-account"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const wholesale_forecast_by_account_import_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"wholesale"],[2,[7,"/"],[2,[6,"forecast-by-account"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const wholesale_forecast_by_account_node_products_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"wholesale"],[2,[7,"/"],[2,[6,"forecast-by-account"],[2,[7,"/"],[2,[6,"node-products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const wholesale_forecast_by_account_plan_tree_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"wholesale"],[2,[7,"/"],[2,[6,"forecast-by-account"],[2,[7,"/"],[2,[6,"plan-tree"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const wholesale_forecast_by_account_products_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"wholesale"],[2,[7,"/"],[2,[6,"forecast-by-account"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

export const wholesale_forecast_by_account_upsert_path = /*#__PURE__*/ __jsr.r({"market_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"m"],[2,[7,"/"],[2,[3,"market_slug"],[2,[7,"/"],[2,[6,"wholesale"],[2,[7,"/"],[2,[6,"forecast-by-account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const wireframes_atlas_ai_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"atlas-ai"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const wireframes_dashboard_path = /*#__PURE__*/ __jsr.r({"role":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[3,"role"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wireframes_home_all_markets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"all-markets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wireframes_home_market_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"market"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wireframes_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[1,[2,[8,"."],[3,"format"]]]]]);

export const wireframes_inventory_empty_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"empty"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wireframes_inventory_sku_path = /*#__PURE__*/ __jsr.r({"warehouse_id":{"r":true},"sku_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"warehouse"],[2,[7,"/"],[2,[3,"warehouse_id"],[2,[7,"/"],[2,[6,"sku"],[2,[7,"/"],[2,[3,"sku_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

export const wireframes_inventory_warehouse_path = /*#__PURE__*/ __jsr.r({"warehouse_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"warehouse"],[2,[7,"/"],[2,[3,"warehouse_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const wireframes_inventory_with_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"inventory"],[2,[7,"/"],[2,[6,"with-data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wireframes_plan_actuals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"actuals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wireframes_plan_actuals_landing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"plan"],[2,[7,"/"],[2,[6,"actuals-landing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wireframes_purchase_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wireframes_purchase_plan_path = /*#__PURE__*/ __jsr.r({"plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[6,"plans"],[2,[7,"/"],[2,[3,"plan_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

export const wireframes_purchase_plans_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wireframes_push_review_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"push"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

export const wireframes_sidebar_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"sidebar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const wireframes_top_nav_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"top-nav"],[1,[2,[8,"."],[3,"format"]]]]]]]);

export const wireframes_wholesale_monthly_forecast_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wireframes"],[2,[7,"/"],[2,[6,"wholesale"],[2,[7,"/"],[2,[6,"monthly-forecast"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

